const CAMEL_CASE_REGEX = /([a-z])([A-Z])/g;

export const camelCaseToDash = (myStr) => myStr.replace(CAMEL_CASE_REGEX, '$1-$2').toLowerCase();
